import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { HeaderComponent } from '../../header/header.component';
import { InfosPatientCardComponent } from '../../infos-patient-card/infos-patient-card.component';
import { TraitementCardComponent } from '../../traitement/traitement-card/traitement-card.component';
import { TelesuiviCardComponent } from '../../telesuivi/telesuivi-card/telesuivi-card.component';
import { MaterielListCardComponent } from '../../materiel/materiel-list-card/materiel-list-card.component';
import { Patient } from '../../models/patient';
import { ActivatedRoute } from '@angular/router';
import { PatientService } from '../../services/patient.service';
import { AuthService } from '../../services/auth.service';
import { Telesuivi } from '../../models/telesuivi';
import { DetailTelesuivi } from '../../models/detailTelesuivi';
import { PrescriptionList } from '../../models/prescription';
import { InterventionList } from '../../models/intervention';
import { InterventionListCardComponent } from '../../intervention/intervention-list-card/intervention-list-card.component';
import { PatientComplement } from '../../models/patientComplement';
import { CommonService } from '../../services/common.service';
import { PrescriptionListCardComponent } from '../../prescription/prescription-list-card/prescription-list-card.component';

@Component({
  selector: 'app-patient-page',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    InfosPatientCardComponent,
    TraitementCardComponent,
    TelesuiviCardComponent,
    MaterielListCardComponent,
    InterventionListCardComponent,
    PrescriptionListCardComponent,
  ],
  templateUrl: './patient-page.component.html',
  styleUrl: './patient-page.component.scss',
})
export class PatientPageComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private readonly patientService = inject(PatientService);
  readonly authService = inject(AuthService);
  readonly commonService = inject(CommonService);

  patient0: WritableSignal<Patient | undefined> = signal(undefined);
  activite?: string;

  isNumber(varTest: any): boolean {
    return typeof varTest == 'number';
  }

  number(varTest: any): number {
    return parseFloat(varTest);
  }

  canEdit: boolean = false;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.activite = params['activite'];
    });
    this.loadPatientData();
  }
  
  loadPatientData(): void {

    this.route.params.subscribe((params) => {
      this.patientService.pullDetail(params['id']).subscribe({
        next: (patient: Patient) => {
          this.patient0.set(patient);

          this.patientService.pullTelesuivi(patient).subscribe({
            next: (telesuivi: Telesuivi) => {
              let temp = this.patient0();
              temp!.telesuivi = telesuivi;
              this.patient0.set(temp);
            },
            error: () => {},
          });

          this.patientService.pullDetailTelesuivi(patient).subscribe({
            next: (detailTelesuivi: DetailTelesuivi) => {
              let temp = this.patient0();
              temp!.detailTelesuivi = detailTelesuivi;
              this.patient0.set(temp);
            },
            error: () => {},
          });

          this.patientService.pullComplement(patient).subscribe({
            next: (patientComplement: PatientComplement) => {
              let temp = this.patient0();
              temp!.patientComplement = patientComplement;
              this.patient0.set(temp);
            },
            error: () => {},
          });

          this.patientService.pullPrescriptionList(patient).subscribe({
            next: (prescription: PrescriptionList) => {
              let temp = this.patient0();
              temp!.prescriptionList = prescription;
              this.patient0.set(temp);
            },
            error: () => {},
          });

          this.patientService.pullInterventionList(patient).subscribe({
            next: (interventionList: InterventionList) => {
              let temp = this.patient0();
              temp!.interventionList = interventionList;
              this.patient0.set(temp);
            },
          });
        },
      });
    });
  }
}
